/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Tournament_1_HeadingInputs */

const en_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prevention-focused pedagogy`)
};

const es_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedagogía centrada en la prevención`)
};

const de_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Präventionsorientierte Pädagogik`)
};

const zh_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以预防为核心的教学法`)
};

const ar_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيداغوجيا مركّزة على الوقاية`)
};

const fr_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pédagogie axée sur la prévention`)
};

const vi_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sư phạm tập trung phòng ngừa`)
};

const sw_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ufundishaji unaolenga kuzuia makosa`)
};

const th_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสอนที่เน้นการป้องกัน`)
};

const bs_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedagogija usmjerena na prevenciju`)
};

const ja_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予防を重視した指導法`)
};

const ko_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예방 중심의 교수법`)
};

const pt_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma pedagogia voltada à prevenção`)
};

const it_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una didattica centrata sulla prevenzione`)
};

const sv_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förebyggande pedagogik`)
};

const nl_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op preventie gerichte didactiek`)
};

const da_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forebyggelsesfokuseret pædagogik`)
};

const nb_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forebyggingsfokusert pedagogikk`)
};

const fi_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ennaltaehkäisyyn keskittyvä pedagogiikka`)
};

const pl_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedagogika nastawiona na zapobieganie`)
};

const ru_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Педагогика предотвращения ошибок`)
};

const tr_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önleme odaklı pedagoji`)
};

const hi_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचाव पर केंद्रित प्रशिक्षण`)
};

const id_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedagogi yang berfokus pada pencegahan`)
};

const ms_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedagogi berteraskan pencegahan`)
};

const cs_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedagogika zaměřená na prevenci`)
};

const el_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παιδαγωγική με επίκεντρο την πρόληψη`)
};

const he_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פדגוגיה ממוקדת מניעה`)
};

const af_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorkomingsgerigte pedagogiek`)
};

const hu_method_content_step_03_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megelőzésközpontú pedagógia`)
};

/**
* | output |
* | --- |
* | "Prevention-focused pedagogy" |
*
* @param {Method_Content_Step_03_Detail_Tournament_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_tournament_1_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Tournament_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Tournament_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_tournament_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_tournament_1_heading(inputs)
	return en_method_content_step_03_detail_tournament_1_heading(inputs)
});